import { render, staticRenderFns } from "./ProductsContainerView.vue?vue&type=template&id=6d7d1908&"
import script from "./ProductsContainerView.vue?vue&type=script&lang=js&"
export * from "./ProductsContainerView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports